import { Link } from "react-router-dom";
import { Column } from "react-table";
import { formatDate } from "../../api/DateUtils";
import {
  GetIncidentsFromComplianceInvestigationFetchUrl,
  IIncident,
} from "../../api/IIncident";
import { GetIncidentPageUrl } from "../../leap-pages/routeFactory";
import { Grid } from "../Grid";
import { IncidentIcon } from "../icons/LeapIcons";
import { IncidentsGridProps } from "./IncidentsGridProps";

const IncidentsGrid = ({
  relatedRecordType,
  relatedrecordId,
  licenceProfile,
}: IncidentsGridProps) => {
  const getFetchUrlFactory = (relatedId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      switch (relatedRecordType) {
        case "CI":
        default:
          return GetIncidentsFromComplianceInvestigationFetchUrl(
            relatedId,
            pageNo,
            recordsPerPage,
            searchText,
            filters
          );
      }
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(relatedrecordId);

  const tableColumnsBig: Column<Record<string, IIncident>>[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td style={{ paddingTop: "6px" }}>
              <span>
                <IncidentIcon />
              </span>
            </td>
            <td>
              <Link
                to={GetIncidentPageUrl(
                  licenceProfile.profileNo,
                  rowInfo.row.original.incidentid
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Start Date",
      accessor: "approximatestart",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Status",
      accessor: "status",
      Filter: false,
      filter: "includes",
    },
    {
      Header: "Category",
      accessor: "incidentcategory",
      Filter: false,
      filter: "includes",
    },
    {
      Header: "Subject",
      accessor: "subject",
      Filter: false,
      filter: "includes",
    },
  ];

  const tableColumnsSmall: Column<Record<string, IIncident>>[] = [
    {
      Header: "Ref. No.",
      accessor: "reference",
      Filter: false,
      filter: "includes",
      Cell: (rowInfo: any) => (
        <table>
          <tr>
            <td style={{ paddingTop: "6px" }}>
              <span>
                <IncidentIcon />
              </span>
            </td>
            <td>
              <Link
                to={GetIncidentPageUrl(
                  licenceProfile.profileNo,
                  rowInfo.row.original.incidentid
                )}
              >
                {rowInfo.value}
              </Link>
            </td>
          </tr>
        </table>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      Filter: false,
      filter: "includes",
    },
    {
      Header: "Subject",
      accessor: "subject",
      Filter: false,
      filter: "includes",
    },
  ];

  var bodyElements = (
    <div>
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={true}
        />
      </div>
    </div>
  );

  return bodyElements;
};

export { IncidentsGrid };
